export default "__VITE_ASSET__BpGbzcRT__"